export default "__VITE_ASSET__BNd$TeIw__"